import React from 'react';
import { Chip } from '@mui/material';

interface ReceivingLogRow {
  progress_label: string;
  fully_received: boolean;
}

export const receivingLogColumns = [
  { name: 'Received', selector: 'received_at', sortable: true, minWidth: '100px'  },
  { name: 'PO', selector: 'po_no', sortable: true },
  { name: 'Vendor', selector: 'vendor_name', sortable: true },
  { name: 'Order #', selector: 'order_no', sortable: true },
  { name: 'Qty', selector: 'piece_count', sortable: true },
  {
    name: 'PO progress',
    selector: 'progress_label',
    sortable: true,
    cell: (row: ReceivingLogRow) => (
      <Chip label={row.progress_label} size="small" color={row.fully_received ? 'error' : 'warning'} />
    ),
    minWidth: '110px',
  },
  { name: 'Fully received on', selector: 'fully_received_on', sortable: true, minWidth: '100px' },
  { name: 'Warehouse', selector: 'warehouse_name', sortable: true },
  { name: 'Rack', selector: 'rack', sortable: true },
  { name: 'Shelf', selector: 'shelf', sortable: true },
  { name: 'Bin', selector: 'bin', sortable: true },
  { name: 'Received by', selector: 'received_by_name', sortable: true },
  { name: 'Department', selector: 'department_name', sortable: true },
];
